import { z } from 'zod';
import { AnimalSpecies, animalSpeciesSchema } from './AnimalSpecies';
import { HerdType, herdTypeSchema } from './HerdType';

export interface Herd {
    id: string;

    creatorId: number;
    createdAt: Date;
    updatedAt: Date;

    name: string;
    animalSpecies: AnimalSpecies;
    herdType: HerdType | null;
}

export const herdSchema = z.object({
    id: z.string().uuid(),

    creatorId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    name: z.string(),
    animalSpecies: animalSpeciesSchema,
    herdType: herdTypeSchema.nullable(),
});

export const mockHerd = ({
    id = '1f6668e5-8410-4b89-80bb-ae625ec87a86',

    creatorId = 1,
    createdAt = new Date(),
    updatedAt = new Date(),

    name = 'Mock herd',
    animalSpecies = 'Cow',
    herdType = 'Cattle',
}: Partial<Herd> = {}): Herd => ({
    id,

    creatorId,
    createdAt,
    updatedAt,

    name,
    animalSpecies,
    herdType,
});
